import { userAppPreferencesDefault } from '../../data/user-app-preferences-default';
import {
    UserAppPreferencesModel
} from '../../models/user-app-preferences.model';

/**
 * Update default Briefing template from empty string to 'BRIEFING_1'
 */
export function fromOnePointThreeToOnePointFour(oldDataModel: UserAppPreferencesModel): UserAppPreferencesModel {
    const newModel = new UserAppPreferencesModel();
    newModel.version = '1.4';
    newModel.reportsPrefs = oldDataModel.reportsPrefs;
    newModel.targetingPrefs = oldDataModel.targetingPrefs;
    newModel.monitoringPrefs = oldDataModel.monitoringPrefs;

    if (!newModel.monitoringPrefs.briefingsPrefs.defaultBriefingTemplate) {
        newModel.monitoringPrefs.briefingsPrefs.defaultBriefingTemplate = userAppPreferencesDefault.monitoringPrefs.briefingsPrefs.defaultBriefingTemplate;
    }
    return newModel;
}
